import type { FC, MouseEvent } from 'react';

import { Link } from 'react-router-dom';

import GroupIcon from '@/material-icons/400-24px/group.svg?react';
import LockIcon from '@/material-icons/400-24px/lock.svg?react';

import { Icon } from './icon';

interface CommunityRef {
  id: string;
  slug: string;
  name: string;
  privacy: 'public' | 'private';
}

interface Props {
  community: CommunityRef;
}

const stop = (e: MouseEvent) => {
  // Prevent the parent status row's click handler from triggering when the
  // user clicks the badge — they should land on the community, not the post.
  e.stopPropagation();
};

/**
 * Compact, color-accented chip rendered on a status when it belongs to a
 * community. Clicking it navigates to that community.
 */
export const CommunityBadge: FC<Props> = ({ community }) => {
  const isPrivate = community.privacy === 'private';
  return (
    <Link
      to={`/communities/${community.slug}`}
      className={`community-badge community-badge--${community.privacy}`}
      onClick={stop}
      title={`Posted in ${community.name}`}
    >
      <Icon id='community-badge-icon' icon={isPrivate ? LockIcon : GroupIcon} />
      <span className='community-badge__name'>{community.name}</span>
    </Link>
  );
};
